import { useState } from 'react';

import { FIRST_PAGE_OFFSET, FIRST_PAGE_INDEX } from '@/components/views/BeraJob/BeraReportV2/constants';
import { STRETCH_FILTER } from '@/components/views/BeraJob/BeraReportV2/IdentifiedStretches/utils';

import type { StretchFilter } from '@/components/views/BeraJob/BeraReportV2/IdentifiedStretches/utils';

export function useStretchFilters() {
	const [search, setSearch] = useState<string>('');
	const [page, setPage] = useState<number>(FIRST_PAGE_INDEX);
	const [filter, setFilter] = useState<StretchFilter>(STRETCH_FILTER.ALL);

	function handleSearchChange(value: string): void {
		setSearch(value);
		setPage(FIRST_PAGE_INDEX);
	}

	function handleFilterChange(value: StretchFilter): void {
		setFilter(value);
		setPage(FIRST_PAGE_INDEX);
	}

	function handlePageChange(nextPage: number): void {
		setPage(nextPage - FIRST_PAGE_OFFSET);
	}

	return {
		search,
		page,
		filter,
		handleSearchChange,
		handlePageChange,
		handleFilterChange
	};
}
